import React from "react";
import NumberFormat from "react-number-format";
import { Input } from "./";

// export function NumberInput(props) {
//   return <NumberFormat {...props} customInput={Input} />;
// }

export const NumberInput = React.forwardRef((props, ref) => {
  const { min, max } = props;

  const validateMinMax = ({ floatValue }) => {
    let ret = true;
    if (min || max) {
      if (min && floatValue < min) ret = false;
      if (max && floatValue > max) ret = false;
    }
    return ret;
  };

  const checkAllowed = (values) => {
    return validateMinMax(values);
  };

  return (
    <NumberFormat
      ref={ref}
      {...props}
      isAllowed={checkAllowed}
      customInput={Input}
    />
  );
});
